// @vue/component

import { GaIconCommonQr, GaIconCommonQrKz } from '@ga/icons'

const QR_COMPONENT_BY_COUNTRY = {
  kz: GaIconCommonQrKz,
}

export default {
  name: 'ga-mobile-only-stub',
  components: {
    GaIconCommonQr,
    GaIconCommonQrKz,
  },

  setup() {
    const { $gaApp } = useNuxtApp()

    const qrComponent = computed(() => {
      const country = Object.keys(QR_COMPONENT_BY_COUNTRY).find(
        (code) => $gaApp.isCountry[code],
      )

      return country ? QR_COMPONENT_BY_COUNTRY[country] : GaIconCommonQr
    })

    return {
      qrComponent,
    }
  },
}
